/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  AssignDeviceModelIncidentRuleDto,
  CreateIncidentRuleDto,
  DeviceModelIncidentRulesControllerAssign200,
  DeviceModelIncidentRulesControllerAssignPathParameters,
  DeviceModelIncidentRulesControllerCreate201,
  DeviceModelIncidentRulesControllerCreatePathParameters,
  DeviceModelIncidentRulesControllerDeletePathParameters,
  DeviceModelIncidentRulesControllerFindAll200AllOf,
  DeviceModelIncidentRulesControllerFindAllParams,
  DeviceModelIncidentRulesControllerFindAllPathParameters,
  DeviceModelIncidentRulesControllerFindOne200,
  DeviceModelIncidentRulesControllerFindOnePathParameters,
  DeviceModelIncidentRulesControllerUpdate200,
  DeviceModelIncidentRulesControllerUpdatePathParameters,
  UpdateIncidentRuleDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceModelIncidentRulesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Copy one model incident rule template to all devices of this model (skips existing device rules for the same datapoint code)
   */

  assign<TData = DeviceModelIncidentRulesControllerAssign200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelIncidentRulesControllerAssignPathParameters,
    assignDeviceModelIncidentRuleDto: AssignDeviceModelIncidentRuleDto,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/assign`,
      assignDeviceModelIncidentRuleDto,
    );
  }
  /**
   * @summary Create a default incident rule on a device model
   */

  create<TData = DeviceModelIncidentRulesControllerCreate201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelIncidentRulesControllerCreatePathParameters,
    createIncidentRuleDto: CreateIncidentRuleDto,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules`,
      createIncidentRuleDto,
    );
  }
  /**
   * @summary List default incident rules for a device model
   */

  findAll<TData = DeviceModelIncidentRulesControllerFindAll200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelIncidentRulesControllerFindAllPathParameters,
    params?: DeviceModelIncidentRulesControllerFindAllParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Get one device model incident rule
   */

  findOne<TData = DeviceModelIncidentRulesControllerFindOne200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    makerId,
    modelId,
    ruleId,
  }: DeviceModelIncidentRulesControllerFindOnePathParameters): Observable<TData> {
    return this.http.get<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/${ruleId}`,
    );
  }
  /**
   * @summary Update a device model incident rule (does not sync to existing devices)
   */

  update<TData = DeviceModelIncidentRulesControllerUpdate200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId, ruleId }: DeviceModelIncidentRulesControllerUpdatePathParameters,
    updateIncidentRuleDto: UpdateIncidentRuleDto,
  ): Observable<TData> {
    return this.http.put<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/${ruleId}`,
      updateIncidentRuleDto,
    );
  }
  /**
   * @summary Delete a device model incident rule template (does not remove device-level rules)
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    makerId,
    modelId,
    ruleId,
  }: DeviceModelIncidentRulesControllerDeletePathParameters): Observable<TData> {
    return this.http.delete<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/incident-rules/${ruleId}`,
    );
  }
}
